import styled from 'styled-components'

export const StyledSpinContainer = styled.div`
  width: 100%;
  text-align: center;
  padding: 100px;
`
